import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Discovery from "../../../../assets/images/CT/discovery.png";

const DiscoveryContent = (props) => {
  const {
    active_player_details,
    dice_ob,
    discard_pile,
    any_other_player_has_cards,
    // card_stolen_from_player,
    // type_of_card_stolen,
    card_stolen_from,
    users,
  } = props;
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  const dice_special = _.get(dice_ob, "dice_special", null);
  const given_card = _.get(dice_ob, "given_card");

  return (
    <>
      <div className="ct-discovery-content">
        <div className="top-content">
          <img src={Discovery} alt="" />
        </div>
        <div className="bottom-content">
          <div className="content">
            <p>
              {`${active_player_details?.display_name} `}
              {playingParams?.discovery?.headline}
            </p>
            {dice_special === null && <h4>{playingParams?.discovery?.info}</h4>}
            {dice_special && dice_special >= 1 && dice_special <= 3 && (
              <>
                <h4>{playingParams?.discovery?.dumpster_dive}</h4>
                {discard_pile && discard_pile.length > 0 ? (
                  <p>
                    {playingParams?.discovery?.dumpster_dive_info_1}
                    {given_card} {playingParams?.discovery?.dumpster_dive_info_2}
                  </p>
                ) : (
                  <p>{playingParams?.discovery?.dumpster_dive_info_empty}</p>
                )}
              </>
            )}
            {dice_special && dice_special >= 4 && dice_special <= 5 && (
              <>
                <h4>{playingParams?.discovery?.share_the_wealth}</h4>
                {card_stolen_from === null ? (
                  <p>{playingParams?.discovery?.share_the_wealth_info}</p>
                ) : (
                  <p>
                    {playingParams?.discovery?.share_the_wealth_info_1}
                    {card_stolen_from.card_type}
                    {playingParams?.discovery?.share_the_wealth_info_2}
                    {users &&
                      users.length > 0 &&
                      _.find(users, { player_id: card_stolen_from?.player_id })?.display_name}
                  </p>
                )}
              </>
            )}
            {dice_special && dice_special === 6 && (
              <>
                <h4>{playingParams?.discovery?.its_all_mine}</h4>
                {any_other_player_has_cards() ? (
                  <p>{playingParams?.discovery?.its_all_mine_info}</p>
                ) : (
                  <p>{playingParams?.discovery?.its_all_mine_info_empty}</p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryContent);
